export const PathRegex = /(~+)([\S\s]+)/;

export const PathUtil = {
	toAbsolutePath: (parentPath: string, name: string): string => {
		const groups = parentPath.match(PathRegex);
		// если путь абсолютный, просто возвращает его
		if (!groups) {
			return parentPath;
		}
		const backs = groups[1];
		let curParts = name.split('.');
		const relParts = groups[2].split('.');
		if (curParts.length >= backs.length) {
			curParts = curParts.slice(0, curParts.length - backs.length);
		} else {
			console.groupCollapsed('Invalid path or currentPath');
			console.warn('Invalid path or currentPath');
			console.warn('parentPath - ', parentPath);
			console.warn('name - ', name);
			console.groupEnd();
		}
		return curParts.concat(relParts).join('.');
	},

	/**
	 * Является ли путь относительным
	 */
	isPathRelative: (path: any) => {
		return !!path.match(PathRegex);
	},

	getFullPath: (model: any) => {
		return model.FullPath;
	},

	getFullElementPathInternal: (model: any) => {
		const pathParts = model.Path.split('.');
		let curPath = pathParts[pathParts.length - 1];
		if (
			model.Parent &&
			model.Parent.elementDescriptor.DescriptorKey ===
				'CollectionFormDescriptor'
		) {
			const items = model.Parent.CollectionItems();
			const index = items.indexOf(model);
			curPath =
				PathUtil.getFullElementPathInternal(model.Parent) +
				'[' +
				index +
				']';
		} else if (model.Parent) {
			curPath =
				PathUtil.getFullElementPathInternal(model.Parent) +
				'.' +
				curPath;
		}
		return curPath;
	},
};
